import { BreakpointObserver } from '@angular/cdk/layout';

import { DropdownItem } from './models/dropdown-item.model';
import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'unh-dropdown-legacy',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent {
  isOpen = false;
  get isMobile() {
      return this.BreakpointObserver.isMatched('(max-width: 768px)');
  }

  @Input() items;
  @Input() showTitleTextMobile = false;

  @Input() optionsHoverText: string;

  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onOptionSelected = new EventEmitter<DropdownItem | string>();
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onOpenChanged = new EventEmitter<boolean>();


  constructor(
    private BreakpointObserver: BreakpointObserver
  ) { }


  selectOption(option: DropdownItem) {
    if (this.isMobile) {
    this.onOptionSelected.emit('dropdown');

    } else {
    this.onOptionSelected.emit(option);

    }

  }
  unHighilghtItem(option: DropdownItem) {
    if (this.isMobile) {
      this.onOptionSelected.emit('dropdown');

      } else {
      this.onOptionSelected.emit(option);

      }
  }

  handleClickedOut(isClickedOut) {
    if(!isClickedOut) {
      this.isOpen = isClickedOut;
    }
  }

  handleButtonTrigger() {
    this.isOpen = !this.isOpen
  }

  preventClick(e) {
    e.stopPropagation();
    e.preventDefault();
    if (!this.isMobile) {
      this.onOpenChanged.emit(this.isOpen)
    } else {
      this.onOptionSelected.emit('dropdown');
    }
  }
}
